import { v4 as uuidv4 } from "uuid";
import { IDENTITY_ID } from "./constants";

export const generateV4UUID = () => uuidv4();

export const getIdentityId = () => {
  return localStorage.getItem(IDENTITY_ID);
};
